import { AudioPlayContext } from '@/contexts/AudioPlayContext';
import { CdnContext } from '@/contexts/CdnContext';
import { getLocaleByCode } from '@/models/Locale';
import { GameType as CommonGameType } from '@/models/games/enums/GameType';
import { getHostById } from '@/modules/host/slice';
import { getLandingState } from '@/modules/main/selector';
import { RootState } from '@/store/store';
import Box from '@mui/material/Box';
import { Dispatch, SetStateAction, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { DialogContext } from '../..';
import './index.scss';

type GameRulesProps = {
    setIsOpen: Dispatch<SetStateAction<boolean>>;
    hash?: string;
    gameType?: CommonGameType;
};

export const GameRules = (props: GameRulesProps) => {
    const { setIsOpen, hash, gameType } = props;

    const params = useParams();
    const hostId = Number(params.hostId);
    const { gameRuleUrl } = useContext(CdnContext);
    const { playButtonAudio } = useContext(AudioPlayContext);
    const { setExtraCloseHandler } = useContext(DialogContext);

    const { GameType } = useSelector((state: RootState) =>
        getHostById(state, hostId)
    );
    const { webView } = useSelector(getLandingState);

    const { i18n } = useTranslation();

    const currentCode = i18n.language;
    const gameRuleLanguage = getLocaleByCode('long', currentCode).short;
    let openSrc = `${gameRuleUrl}?langcode=${gameRuleLanguage}`;
    if (hash) openSrc += `&hash=${hash}`;
    if (gameType) {
        openSrc += `&gametype=${gameType}`;
    } else if (GameType) {
        openSrc += `&gametype=${GameType}`;
    }
    // if (os.name?.toLowerCase() === 'ios' && webView) {
    //     openSrc += '&parenturl=' + encodeURIComponent(window.location.href);
    // }

    const handleCancel = () => {
        setIsOpen(false);
        playButtonAudio();
    };

    useEffect(() => {
        setExtraCloseHandler(() => () => {});
    }, []);

    useEffect(() => {
        if (!webView) {
            handleCancel();
        }
    }, [webView, setIsOpen]);

    if (webView) {
        return (
            <Box className="game-rule-container">
                <iframe className="game-rule-iframe" src={openSrc} />
                {/* <CancelButton width={'2.25rem'} height={'2.25rem'} onClick={handleCancel} /> */}
            </Box>
        );
    } else {
        window.open(openSrc, 'GameRules');
        return <></>;
    }
};
